/**
 * The language a backend mail goes out in. FusionAuth resolves the locale from
 * the user record, which does not exist for the login-free cancellation, so the
 * page picks the language and the backend the matching template. German is the
 * fallback because the contract language and the AGB are German.
 */
export type MailLanguage = "de" | "en";

/** Maps the active i18n language onto the two languages the templates exist in. */
export const resolveMailLanguage = (i18nLanguage: string): MailLanguage =>
  i18nLanguage.toLowerCase().startsWith("en") ? "en" : "de";
